"use client";

import { Mail } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const faqs = [{
    question: "What areas do you serve for roofing?",
    answer: "We proudly serve Garden City, Kansas, and all communities within a 1.5-hour driving radius. This includes Dodge City, Liberal, Ulysses, Scott City, Syracuse, Sublette, Lakin, Holcomb, Cimarron, and surrounding areas."
  }, {
    question: "Do you offer free roof inspections?",
    answer: "Yes, we provide professional, no-obligation roof inspections. Our team will assess your roof's condition, identify any storm damage or wear, and provide a transparent report on the best path forward for your home."
  }, {
    question: "How does your cash home buying process work?",
    answer: "We buy houses as-is nationwide. You don't need to worry about repairs, cleaning, or realtor commissions. Simply contact us, and we will provide a fair cash offer. If you accept, we can close quickly on your timeline."
  }, {
    question: "Can you help with insurance claims?",
    answer: "Absolutely. We specialize in insurance claim assistance for storm damage. We work directly with you to ensure your claim is documented correctly, helping you navigate the process to get your roof repaired or replaced efficiently."
  }, {
    question: "Do I need to make repairs before selling my house?",
    answer: "No. We buy houses in any condition and in any situation. Whether your property needs major repairs or just a fresh start, we handle everything so you don't have to spend a dime on renovations."
  }, {
    question: "Are your roofing services for residential or commercial?",
    answer: "We provide expert roofing services for both residential and commercial properties. From small home repairs to large-scale commercial roof replacements, our team is equipped to handle projects of any size with professional precision."
  }, {
    question: "What makes your cash offer process fast?",
    answer: "Because we are direct buyers, we eliminate the need for bank approvals, inspections, and lengthy closing processes. We provide a fair cash offer in minutes and can finalize the sale on your schedule."
  }, {
    question: "How can I get started with a project?",
    answer: "Getting started is simple. You can call us directly at (620) 640-0354 or email us at LuxuryConstructionInvestments@gmail.com. We are ready to discuss your roofing needs or provide a cash offer for your property today."
  }];
  return <section data-section-id="995" id="frequently-asked-questions" className="relative overflow-hidden py-24 md:py-32 bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute -bottom-10 -right-10 hidden md:block" style={{
      opacity: 0.03
    }} aria-hidden="true">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/construction_blueprint_overlay.webp" alt="" className="h-[460px] w-[460px] object-contain" loading="lazy" decoding="async" />
      </div>

      <div ref={ref} className={`relative mx-auto max-w-4xl px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex justify-center">
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-primary">
            Common Inquiries &mdash; F.A.Q.
          </span>
        </div>

        {}
        <h2 className="mt-8 text-center font-default font-semibold leading-[1.05] text-[44px] sm:text-[52px] md:text-[64px] text-foreground">
          Questions
          <br />
          about our
          <br />
          services.
        </h2>

        {}
        <div className="mx-auto mt-16 max-w-[880px]">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b border-border">
                <AccordionTrigger className="group py-7 hover:no-underline [&>svg]:hidden">
                  <span className="font-default font-medium text-xl md:text-[22px] leading-snug pr-4 text-foreground">
                    {faq.question}
                  </span>
                  <span className="ml-auto flex h-8 w-8 shrink-0 items-center justify-center text-2xl font-light transition-transform duration-300 ease-out group-data-[state=open]:rotate-45 text-primary" aria-hidden="true">
                    +
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pr-12">
                  <p className="font-default text-base leading-[1.7] max-w-[720px] text-muted-foreground">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {}
        <div className="mt-20 flex justify-center">
          <div className="w-full max-w-xl px-8 py-10 text-center border border-border bg-card">
            <p className="font-default text-lg md:text-xl leading-relaxed text-foreground">
              Have a different question?
              <br />
              We are ready to assist you.
            </p>
            <div className="mt-7">
              <Button asChild variant="outline" size="lg" className="font-mono text-xs tracking-[0.2em] uppercase bg-primary text-primary-foreground hover:bg-primary/90 border-none">
                <Link to="/ContactUsPage">
                  <Mail className="size-4" />
                  Contact Us Today
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}